import React from 'react';

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M14.33,10.81H10.7a.79.79,0,0,0-.56.23.82.82,0,0,0-.24.57.82.82,0,0,0,.8.8h1.92A6.4,6.4,0,0,1,1.6,8a.81.81,0,0,0-.23-.57A.81.81,0,0,0,.8,7.2a.81.81,0,0,0-.57.23A.81.81,0,0,0,0,8a8,8,0,0,0,9.41,7.85,7.89,7.89,0,0,0,4.09-2.07V15.2a.82.82,0,0,0,.24.57.81.81,0,0,0,1.13,0,.81.81,0,0,0,.23-.57V11.6a.79.79,0,0,0-.77-.79Z" />
    <path d="M8,0A8,8,0,0,0,2.5,2.22V.8A.82.82,0,0,0,2.26.23a.81.81,0,0,0-1.13,0A.81.81,0,0,0,.9.8V4.4A.81.81,0,0,0,1.13,5a.79.79,0,0,0,.57.23H5.3A.79.79,0,0,0,5.86,5a.8.8,0,0,0,0-1.14A.79.79,0,0,0,5.3,3.6H3.38A6.4,6.4,0,0,1,14.4,8,.8.8,0,1,0,16,8a8,8,0,0,0-2.34-5.66A8,8,0,0,0,8,0Z" />
  </svg>
);

export default RefreshIcon;
